<template>
  <v-app>
    <TopBar v-if="isAuthed" />
    <v-main >
      <router-view />
    </v-main>
    <BottomNav v-if="isAuthed" />
    <CookieConsentBanner />
  </v-app>
</template>

<script>
import { mapGetters } from "vuex";
import TopBar from "./components/TopBar.vue";
import BottomNav from "./components/BottomNav.vue";
import CookieConsentBanner from "./components/CookieConsentBanner.vue";

function calcViewportBottomInset() {
  const vv = window.visualViewport;
  if (!vv) return 0;
  return Math.max(0, Math.round(window.innerHeight - (vv.height + vv.offsetTop)));
}

export default {
  components: { TopBar, BottomNav, CookieConsentBanner },

  mounted() {
    const updateInsets = () => {
      const inset = calcViewportBottomInset();
      document.documentElement.style.setProperty(
        "--vv-safe-bottom",
        inset + "px"
      );
    };

    updateInsets();

    window.addEventListener("resize", updateInsets, { passive: true });
    if (window.visualViewport) {
      window.visualViewport.addEventListener("resize", updateInsets, { passive: true });
      window.visualViewport.addEventListener("scroll", updateInsets, { passive: true });
    }
  },

  computed: {
    ...mapGetters("auth", ["isAuthed"]),
  },
};
</script>

<style>
.safe-main {
  /* Top: app-bar (56) + notch */
  padding-top: calc(56px + env(safe-area-inset-top));

  /* Bottom:
     - 56px del bottom nav
     - safe-area real si funciona
     - fallback visualViewport si env() da 0
  */
  padding-bottom: calc(
    56px +
    max(env(safe-area-inset-bottom), var(--vv-safe-bottom, 0px))
  );
}
</style>
